const trMessages = {
    datepicker: {
        toggleCalendar: 'Takvimi aç/kapat'
    },
    calendar: {
        today: 'Bugün'
    },
    dateinput: {
        increment: 'Değeri artır',
        decrement: 'Değeri azalt'
    },
    numerictextbox: {
        increment: 'Değeri artır',
        decrement: 'Değeri azalt'
    },
    grid: {
        groupPanelEmpty: 'Bir sütun başlığını sürükleyip buraya bırakın, bu kritere göre gruplandırın',
        noRecords: 'Veri bulunamadı.',
        pagerFirstPage: 'İlk sayfaya git',
        pagerPreviousPage: 'Önceki sayfaya git',
        pagerNextPage: 'Sonraki sayfaya git',
        pagerLastPage: 'Son sayfaya git',
        pagerPage: 'Sayfa',
        pagerOf: ' / ',
        pagerTotalPages: '{0}',
        pagerItems: 'öğe',
        pagerInfo: '{0} - {1} / {2} öğe',
        pagerItemsPerPage: 'Sayfa başına öğe',
        filterEqOperator: 'Eşittir',
        filterNotEqOperator: 'Eşit değildir',
        filterIsNullOperator: 'Boş (null)',
        filterIsNotNullOperator: 'Boş değil (null değil)',
        filterIsEmptyOperator: 'Boş',
        filterIsNotEmptyOperator: 'Boş değil',
        filterStartsWithOperator: 'Şununla başlar',
        filterContainsOperator: 'İçerir',
        filterNotContainsOperator: 'İçermez',
        filterEndsWithOperator: 'Şununla biter',
        filterGteOperator: 'Büyük veya eşit',
        filterGtOperator: 'Büyüktür',
        filterLteOperator: 'Küçük veya eşit',
        filterLtOperator: 'Küçüktür',
        filterIsTrue: 'Pasif',
        filterIsFalse: 'Aktif',
        filterBooleanAll: '(Tümü)',
        filterAfterOrEqualOperator: 'Şundan sonra veya eşit',
        filterAfterOperator: 'Şundan sonra',
        filterBeforeOperator: 'Şundan önce',
        filterBeforeOrEqualOperator: 'Şundan önce veya eşit',
        filterSubmitButton: 'Filtrele',
        filterClearButton: 'Filtreleri temizle',
        filterAndLogic: 'VE',
        filterOrLogic: 'VEYA',
        filterTitle: 'Filtrele',
        sortAscending: 'Artan sırala',
        sortDescending: 'Azalan sırala',
        searchPlaceholder: 'Ara',
        filterCheckAll: 'Tümünü seç',
        pagerItemPerPage: 'Sayfa başına öğe',
        filterChooseOperator: 'Operatör seç',
        filterSelectedItems: 'Seçili öğeler',
        filterAriaLabel: 'Filtreleme',
        sortAriaLabel: 'Sıralanabilir',
        groupColumn: 'Grup sütunu',
        groupExpand: 'Grubu genişlet',
        groupCollapse: 'Grubu daralt',
        groupPanelAriaLabel: 'Grup paneli',
        ungroupColumn: 'Gruptan çıkar',
        detailExpand: 'Detay satırını genişlet',
        detailCollapse: 'Detay satırını daralt'
    }
};
export default trMessages;
